/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagementDeleteMemberAddressResponse } from './MemberManagementDeleteMemberAddressResponse';

export type MemberManagementDeleteMemberAddressResponseApiRespoonse = {
    data?: MemberManagementDeleteMemberAddressResponse;
    status?: MemberManagementDeleteMemberAddressResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace MemberManagementDeleteMemberAddressResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

